import PageTemplate from "./PageTemplate";
import * as userActions from "../actions/user";
import * as moduleActions from "../actions/module";
import * as modulesActions from "../actions/modules";
import {connect} from "redux-vue";
import {filterFn, maybePluralize} from "../helpers/tools";
import ModuleItem from "../components/ModuleItem";
import ModuleCard from "../components/ModuleCard";
import LoadingIndicator from "../components/LoadingIndicator";
import ApiError from "../components/ApiError";
import blingblingsquare from "../assets/blingblingsquare.gif";
import blingblingcircle from "../assets/blingblingcircle.gif";
import {getScreenSize} from "../helpers/screens";

const CoursesPage = {
  props: [
    "user",
    "module",
    "modules",
    "setModule",
    "fetchModules",
    "enrollModule",
    "unEnrollModule",
    "setCompleteCount",
  ],
  data() {
    return {
      filter: "",
      blingbling: false
    };
  },
  computed: {
    completedCount: function () {
      return this.modules.collection.filter(
        i => i.enrolled && i.completed
      ).length;
    }
  },
  watch: {
    module(nextVal, val) {
      if (
        (nextVal.enrollError !== val.enrollError && nextVal.enrollError)
        || (nextVal.unEnrollError !== val.unEnrollError && nextVal.unEnrollError)
      ) {
        const error = nextVal.enrollError || nextVal.unEnrollError;
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          Snackbar.show({
            showAction: false,
            text: error.response.data.message,
            customClass: "bg-red-500 text-white"
          });
        }
      }
      if (!val.enrollSuccess && nextVal.enrollSuccess) {
        Snackbar.show({
          text: `You are enrolled in Course: ${this.module.model.name}`,
          actionText: "Undo",
          pos: 'top-center',
          backgroundColor: '#F6CC5D',
          textColor: '#373737',
          actionTextColor: '#373737',
          onActionClick: element => {
            element.style.opacity = 0;
            this.onPressUnEnroll();
          }
        });
      }
    }
  },
  mounted() {
    this.checkCompletedCount();
    this.handleAnchorClick = function (event) {
      const element = event.target;
      if (element.tagName == 'A' && element.hash) {
        event.preventDefault();
        document.querySelector(element.hash).scrollIntoView({
          behavior: 'smooth'
        });
      }
    };
    document.addEventListener("click", this.handleAnchorClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleAnchorClick);
  },
  methods: {
    /**
     *
     * @param prop
     * @param value
     */
    sync(prop, value) {
      this[prop] = value.trim();
    },
    /**
     *
     * @param row
     * @returns {function(): (Function|*)}
     */
    onPressDetails(row) {
      return () => this.setModule(row);
    },
    /**
     *
     * @returns {Promise<void>}
     */
    async checkCompletedCount() {
      await this.fetchModules;
      if (this.completedCount > this.user.completes && this.user.completes > -1) {
        this.showBlingBling();
      }
      this.setCompleteCount(this.completedCount);
    },
    /**
     *
     */
    showBlingBling() {
      this.blingbling = true;
      setTimeout(() => {
        this.blingbling = false;
      }, 4000);
    },
    /**
     *
     * @param row
     * @returns {Function}
     */
    onPressEnroll(row) {
      return () => {
        const isAuthorized = !!(this.user.token && this.user.model);
        if (!isAuthorized) {
          this.$router.push('/en/register');
        } else {
          const hasActivity = (row.lessons || []).some(
            lesson => !!lesson.activities.length
          );
          if (hasActivity) {
            this.enrollModule(row);
          } else {
            Snackbar.show({
              text: "This module will be available soon",
              pos: 'top-center',
              backgroundColor: '#F6CC5D',
              textColor: '#373737',
              actionTextColor: '#373737',
            });
          }
        }
      };
    },
    /**
     *
     */
    onPressUnEnroll() {
      this.unEnrollModule(this.module.model);
    },
  },
  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const unEnrolledCollection = this.modules.collection.filter(each => !each.enrolled);
    const enrolledCollection = this.modules.collection.filter(each => each.enrolled && !each.completed);
    const completedCollection = this.modules.collection.filter(each => each.enrolled && each.completed);
    const newCollection = this.modules.collection.filter(each => each.new && !each.enrolled);
    const circleBlingBling = this.blingbling && (
      <transition leave-to-class="bling-bling-fade">
        <img src={blingblingcircle} class="-translate-x-1/2 -translate-y-1/2 absolute bling-bling-circle hidden lg:block scale-125 transform z-10" style="left: 50%;top: 50%;"></img>
      </transition>
    );
    const squareBlingBling = this.blingbling && (
      <transition leave-to-class="bling-bling-fade">
        <img src={blingblingsquare} class="-translate-x-1/2 -translate-y-1/2 absolute bling-bling-square lg:hidden transform z-10" style="left: 50%;top: 50%;"></img>
      </transition>
    );
    const headerContent = !enrolledCollection.length && !completedCollection.length
      ? (
        <header class="bg-teal-900 lg:bg-transparent relative">
          <div class="h-56 hidden lg:block"></div>
          <div class="h-56 hidden lg:block"></div>
          <div class="absolute top-0 left-0 h-full w-full bg-center bg-cover hidden lg:block" style="background-image: url(/img/outreachclinic.jpg); background-position-y: -140px;"></div>
          <div class="h-40 bg-center bg-cover lg:hidden" style="background-image: url(/img/hcwandmgr.jpg)"></div>
          <div class="absolute top-0 left-0 h-full w-full hidden lg:block" style="background: linear-gradient(0deg, rgba(0,0,0,0.75) 0%, rgba(255,255,255,0) 100%);"></div>
          <div class="lg:absolute top-0 left-0 h-full w-full flex items-end justify-center p-8 px-5 lg:py-24">
            <h1 class="font-serif text-xl lg:text-4xl text-white text-center lg:leading-snug">
              Welcome, {this.user.model && this.user.model.first_name}!
              <br/>
              Get started by enrolling in your first course.
            </h1>
          </div>
        </header>
      )
      : (
        <header class="relative">
          <div class="h-56 hidden lg:block"></div>
          <div class="h-56 hidden lg:block"></div>
          <div class="absolute top-0 left-0 h-full w-full bg-bottom bg-cover border-b-2" style="background-image: url(/img/hero-courses.jpg);"></div>
          <div class="bg-teal-800 absolute top-0 left-0 h-full w-full" style="opacity: .9;"></div>
          <div class="relative lg:absolute lg:top-0 lg:left-0 h-full w-full">
            <div class="container mx-auto px-6 lg:px-0 py-4 lg:py-24 h-full">
              <div class="flex flex-col lg:flex-row h-full">
                <div class="lg:w-5/12 text-center lg:text-left">
                  <h3 class="font-serif text-2xl lg:text-3xl text-white mb-2 lg:mb-5 w-2/3 lg:w-1/2 mx-auto lg:ml-0">
                    Welcome back, {this.user.model && this.user.model.first_name}!
                  </h3>
                  <p class="text-white italic font-serif text-lg lg:text-2xl lg:w-9/12 mb-5">
                    Look at what you have achieved so far. Keep up the great work!
                  </p>
                  {newCollection.length > 0 && (
                    <div class="bg-green-300 p-1 pl-3 pr-5 rounded-md hidden lg:inline-flex items-center">
                      <i class="mdi mdi-star text-gray-800 text-xl mr-2"></i>
                      <p class="mr-5 text-sm">New courses available!</p>
                      <a href="#newcourses" class="text-blue-700 font-bold text-sm flex items-center">
                        View now
                        <i class="mdi mdi-arrow-down text-lg ml-px"></i>
                      </a>
                    </div>
                  )}
                </div>
                <div class="lg:w-7/12">
                  <div class="flex flex-col lg:flex-row h-full">
                    <div class="lg:w-1/2 border-b lg:border-b-0 lg:border-l border-gray-300 relative">
                      {circleBlingBling}
                      {squareBlingBling}
                      <div class="flex flex-row lg:flex-col items-center justify-center h-full py-4">
                        <div class="rounded-full h-16 lg:h-32 w-16 lg:w-32 border-4 lg:border-8">
                          <div class="h-full w-full flex items-center justify-center">
                            <p class="text-4xl lg:text-6xl text-yellow-500 font-serif transform lg:scale-125">
                              {completedCollection.length}
                            </p>
                          </div>
                        </div>
                        <div class="h-4 w-2"></div>
                        <p class="font-serif italic text-white text-lg lg:text-2xl">
                          {maybePluralize(completedCollection.length, 'Certification')} earned
                        </p>
                      </div>
                    </div>
                    <div class="lg:w-1/2 lg:border-l border-gray-300">
                      <div class="flex flex-row lg:flex-col items-center justify-center h-full py-4">
                        <div class="rounded-full h-16 lg:h-32 w-16 lg:w-32 border-4 lg:border-8">
                          <div class="h-full w-full flex items-center justify-center">
                            <p class="text-4xl lg:text-6xl text-yellow-500 font-serif transform lg:scale-125">
                              {enrolledCollection.length}
                            </p>
                          </div>
                        </div>
                        <div class="h-4 w-2"></div>
                        <p class="font-serif italic text-white text-lg lg:text-2xl">
                          {maybePluralize(enrolledCollection.length, 'Course')} in progress
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      );
    const myCourses = enrolledCollection.length > 0 && (
      <div class="bg-teal-100">
        <div class="container mx-auto px-6 lg:px-0 pt-5 lg:pt-10 z-10 relative">
          <h3 class="lg:text-xl font-bold mb-5">
            My Courses
          </h3>

          <ul class="bg-white">
            <li class="flex border-b-2 py-3 lg:pt-6 px-3 lg:px-8">
              <p class="font-bold lg:text-lg w-6/12">Enrolled Courses</p>
              <p class="text-lg w-6/12 hidden lg:block">Progress</p>
            </li>
            {enrolledCollection.map(each => (
              <li class="relative border-b-2 px-6 lg:px-8">
                <ModuleItem key={each.id} modelProp={each}/>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
    const completedCourses = completedCollection.length > 0 && (
      <div class="bg-teal-100">
        <div class="container mx-auto px-6 lg:px-0 pt-5 lg:pt-10 z-10 relative">
          <ul class="bg-white">
            <li class="border-b-2 py-3 lg:pt-6 px-3 lg:px-8">
              <p class="font-bold lg:text-lg">Completed Courses</p>
            </li>
            {completedCollection.map(each => (
              <li class="relative border-b-2">
                <ModuleItem key={each.id} modelProp={each}/>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
    const filteredCollection = unEnrolledCollection.filter(filterFn(this.filter));
    const moreCourses = this.modules.fetchSuccess && unEnrolledCollection.length > 0 && (
      <div class="bg-teal-100">
        <div class="container mx-auto px-6 lg:px-0 pt-5 lg:pt-10 z-10 relative">
          <div class="flex flex-col lg:flex-row lg:items-center mb-2">
            <h3 class="text-base lg:text-xl font-bold mb-2 lg:mb-0">
              {enrolledCollection.length + completedCollection.length > 0 ? 'More Courses' : 'All Courses'}
            </h3>
            <div class="w-full lg:w-4/12 ml-auto">
              <div class="relative shadow rounded bg-white">
                <input type="text" onInput={e => this.sync("filter", e.target.value)}
                       class="shadow-xs rounded border-0 p-2 lg:p-3 w-full focus:outline-none focus:shadow-outline text-xs lg:text-base"
                       placeholder="What do you what to learn about?"/>
                <div class="absolute top-0 right-0 mt-1 lg:mt-3 mr-3 lg:mr-4">
                  <i class="mdi mdi-magnify"></i>
                </div>
              </div>
            </div>
          </div>

          <ul class="flex flex-wrap -m-3 mt-0">
            {newCollection.length > 0 && this.filter === "" && (
              <li id="newcourses" class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-3">
                <div class="bg-teal-800 rounded-md overflow-hidden h-full">
                  <div class="flex flex-col h-full">
                    <div class="p-4 text-white flex-1 text-center">
                      <i class="mdi mdi-star text-green-300 text-5xl"></i>
                      <h3 class="font-serif italic text-xl lg:text-2xl mb-3">
                        {maybePluralize(newCollection.length, 'New Course')} Added!
                      </h3>
                      <p class="mx-5 mb-3 text-sm lg:text-base">
                        {maybePluralize(newCollection.length, 'new course')} {newCollection.length>1?"have":"has"} been added to the IA Learn library.
                      </p>
                      <p class="mx-5 mb-2 text-sm lg:text-base">
                        Start browsing new courses now!
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            )}
            {filteredCollection.map(each => (
              <li class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-3">
                <ModuleCard key={each.id + this.filter} modelProp={each} highlight={this.filter}/>
              </li>
            ))}
          </ul>
          {this.filter !== "" && filteredCollection.length === 0 && (
            <div class="bg-red-500 mt-5 mx-auto p-5 px-10 text-center text-white lg:w-2/5">
              Your search did not return any modules. Please try another search.
            </div>
          )}
        </div>
      </div>
    );
    const whatsAppAd = (
      <div class="bg-teal-100">
        <div class="container mx-auto py-5 px-6">
          <div class="bg-yellow-500 p-5 rounded-md">
            <div class="flex flex-col lg:flex-row items-center text-gray-800">
              <div class="lg:w-5/12 flex items-center justify-center mb-2 lg:mb-0">
                <i class="mdi mdi-facebook text-5xl lg:text-6xl leading-none"></i>
                <div class="w-2 lg:w-4"></div>
                <p class="font-bold text-base lg:text-3xl">
                  {this.$t('whatsapp_promo.h1')}
                </p>
              </div>
              <p class="lg:w-7/12 text-xs lg:text-xl text-center lg:text-left" domPropsInnerHTML={this.$t('whatsapp_promo.p')}>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
    const apiError = this.modules.fetchError && (
      <ApiError error={this.modules.fetchError} />
    );
    const myCoursesLoading = (
      <div class="bg-white">
        {Array(3).fill()
          .map((i, index) => (
            <div class={"row-loading border-b " + (index > 0 ? "border-t" : "")}></div>
          ))}
      </div>
    );
    const moreCoursesLoading = (
      <div class="flex flex-wrap -m-3 mb-0">
        {Array(getScreenSize() === "sm" ? 2 : 4).fill()
          .map(i => (
            <div class="w-full lg:w-1/4 p-3">
              <div class="bg-white card-loading rounded">
                <div class="bg-gray-200 h-32"></div>
              </div>
            </div>
          ))}
      </div>
    );
    const loading = this.modules.fetch && (
      <div class="bg-teal-100 pt-6">
        <div class="container px-6 lg:px-0 mx-auto opacity-75">
          <h4 class="heading-loading lg:mt-10 mb-6" style="opacity: 35%"></h4>
          {myCoursesLoading}
          <h4 class="heading-loading mt-20 mb-6" style="opacity: 35%"></h4>
          {moreCoursesLoading}
        </div>
      </div>
    );
    return (
      <PageTemplate>
        {headerContent}
        {loading}
        {apiError}
        {myCourses}
        {completedCourses}
        {moreCourses}
        {whatsAppAd}
      </PageTemplate>
    )
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module,
    modules: state.modules,
  };
}

function mapActionToProps(dispatch) {
  return {
    fetchModules: () => dispatch(modulesActions.fetchModules()),
    setModule: module => dispatch(moduleActions.setModule(module)),
    enrollModule: async module => await dispatch(moduleActions.enrollModule(module)),
    setCompleteCount: (completed) => dispatch(userActions.setCompleteCount(completed)),
    unEnrollModule: async module => await dispatch(moduleActions.unEnrollModule(module)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(CoursesPage);
